var courtMap = {
    "江苏": 124,
    "辽宁": 132,
    "安徽": 137,
    "福建": 99,
    "广东": 156,
    "海南": 28,
    "山东": 169,
    "陕西": 318,
    "上海": 28,
    "云南": 148,
    "浙江": 103,
    "吉林": 98,
    "河南": 189,
    "山西": 135,
    "广西": 130,
    "四川": 211,
    "内蒙古": 118,
    "河北": 328,
    "黑龙江": 195,
    "贵州": 338,
    "甘肃": 113,
    "宁夏": 29,
    "青海": 57,
    "北京": 23,
    "重庆": 44,
    "天津": 23
}

export default {
    courtMap
}



//////////////////
// WEBPACK FOOTER
// ./static/js/courtMap.js
// module id = UBaD
// module chunks = 73